<div class="main">
    <div class="section">
        <div class="header">
            <div class="label">
              {{'subscribe.shipmentId' | translate}} #{{dialogData.sin}} | {{dialogData.status}}
            </div>
            <i class='material-icons'(click)="closeDialog();">clear</i>
          </div>
          <div class="body">
              <div class="content">
                  <div class="firstRow" [hidden]="!unsubscribeNow">
                      <div class="statusLabel">
                        {{'subscribe.subStatus' | translate}}
                      </div>
                      <div class="colon">
                        :
                      </div>
                      <div class="yesNo" [ngStyle]="{'color': (subStatus == 'Yes')?'#02f500':'#ff0000'}">
                          {{subStatus}}
                      </div>
                      <div class="submitButton" [ngStyle]="{'background-color': (subStatus == 'Yes')?'#E54131':'#0b64c9'}">
                        <div class="button" (click)="confirm = true">
                          {{(subStatus == 'Yes') ? 'Unsubscribe' : 'Subscribe'}}
                        </div>
                      </div>
                  </div>
                  <div class="secondRow" [hidden]="!unsubscribeNow || subStatus == 'No'" >
                    
                      <div class="consent">
                        {{'subscribe.consentByDriver' | translate}} 
                      </div>
                      <div class="colon">
                        :
                      </div>
                      <div class="yesNo" [ngStyle]="{'color': (consent == 'Yes')?'#02f500':'#ff0000'}">
                        {{consent}}
                    </div>
                  </div>
                  <div class="row" *ngIf="dateTime">
                    <div class="label">{{'subscribe.consentDate' | translate}}</div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">{{dateTime}}</div>
                  </div>
                  <div class="row" *ngIf="carrier">
                    <div class="label">{{'subscribe.carrier' | translate}}</div>
                    <div class="colon">
                      :
                    </div>
                    <div class="value">{{carrier}}</div>
                  </div>
                  <div class="message" *ngIf="message">
                    <div class="mes">
                      {{message}}
                    </div>
                  </div>
                  <div class="con" [hidden]="!confirm" >

                    <div class="confirmation">
                      <span class="text">
                        {{'subscribe.doyouwant' | translate}} {{(subStatus == 'Yes') ? 'Unsubscribe' : 'Subscribe'}}?
                      </span>
                      <span class="yes">
                          <div class="submitButtonYes">
                              <div class="button" (click)="(subStatus == 'Yes') ? unsubscribe() : subscribe()">
                                {{'subscribe.yes' | translate}}
                              </div>
                            </div>
                      </span>
                      <span class="no">
                          <div class="submitButtonNo">
                              <div class="button" (click)="confirm = false">
                                {{'subscribe.no' | translate}}
                              </div>
                            </div>
                      </span>
                  </div>
                  </div>
                  <div class="unsubscribedNow" [hidden]="unsubscribeNow">
                    <div class="unsubscribeText">
                      {{'subscribe.youAre' | translate}} {{(subStatus == 'Yes') ? 'Unsubscribed' : 'Subscribed'}} {{'subscribe.now' | translate}}
                    </div>
                  </div>
              </div>
          </div>
          <div class="note">
            <div class="text">
              {{'subscribe.note' | translate}}
            </div>
              <div class="text">
                {{'subscribe.disclaimer1' | translate}}
              </div>
              <div class="text">
                {{'subscribe.disclaimer2' | translate}}
              </div>
          </div>
    </div>
</div>